<template>
  <div v-if="items.length" class="custom-fields" :class="['custom-fields--length-' + items.length]">
    <Field
      v-for="item in items"
      :key="item.key"
      :value="get(item.key)"
      :schema="item"
      v-on="{
        ...$listeners,
        input: $ev => onInput($ev, item),
        remove: $ev => $emit('remove', $ev),
      }"
    />
  </div>
</template>

<script>
import Field from './Field'
import { Filter } from './utils'
import { assocPath, path } from 'ramda'

export default {
  props: {
    schema: {
      type: Array,
      default: () => [],
    },
    data: Object,
    placement: [String, Array],
    keys: [String, Array],
    validator: Object,
    validatorPrefix: String,
    components: Array,
  },
  watch: {
    '$attrs.value': {
      handler(val) {
        this.value = val || {}
      },
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      value: {},
    }
  },
  computed: {
    items() {
      return Filter(this.schema, { placement: this.placement, keys: this.keys })
    },
  },
  provide() {
    return {
      injection: Object.defineProperties(
        {},
        {
          data: { get: () => this.data || this.value },
          validator: { get: () => this.validator },
          validatorPrefix: { get: () => this.validatorPrefix },
          components: { get: () => this.components },
        },
      ),
    }
  },
  methods: {
    onInput(val, item) {
      this.value = assocPath(item.key.split('.'), val, this.value)
      this.$emit('input', this.value)
    },
    get(key) {
      return path(key.split('.'), this.value)
    },
  },
  components: {
    Field,
  },
}
</script>

<style lang="scss">
.custom-fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem 2rem;

  .kvass-media-droparea,
  .elder-file {
    min-height: 300px;
  }
}
</style>
